import { defineMessages } from 'react-intl';
import View from './View';
import Edit from './Edit';
import iconSVG from './icons/button.svg';

defineMessages({
  button: {
    id: 'Button',
    defaultMessage: 'Button',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.buttonBlock = {
    id: 'buttonBlock',
    title: 'Button',
    group: 'text',
    icon: iconSVG,
    view: View,
    edit: Edit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
